import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import {
	UpdateCommentMutation,
	UpdateCommentMutationVariables,
} from "~/types/__generated/gql/graphql";
import {
	getCommentsByFileIdQueryKey,
	GetCommentsByFileIdResults,
} from "../useGetCommentsByFileId";
import { useAppRouter } from "~/hooks/use-app-router";

const query = /* GraphQL */ `
	mutation UpdateComment($id: ObjectID!, $input: UpdateCommentInput!) {
		updateComment(id: $id, input: $input) {
			_id
			createdAt
			updatedAt
			user
			text
			attachments {
				name
				size
				url
				extension
			}
			comment

			_user {
				firstName
				lastName
				avatar
			}
		}
	}
`;

export type UpdateCommentVariables = UpdateCommentMutationVariables;
export type UpdateCommentResults = UpdateCommentMutation["updateComment"];

export const useUpdateComment = () => {
	const queryClient = useQueryClient();
	const { appQuery } = useAppRouter();

	return useMutation({
		mutationFn: (variables: UpdateCommentVariables) =>
			apiGqlClient
				.request(graphql(query), variables)
				.then((res) => res.updateComment),
		onSuccess: (data) => {
			queryClient.setQueryData<GetCommentsByFileIdResults>(
				getCommentsByFileIdQueryKey(appQuery.fileId!),
				(oldData) => oldData?.map((od) => (od._id === data._id ? data : od)),
			);
		},
	});
};
